
import {  Box, useTheme, TextField,  Button,  MenuItem, Typography, Divider,  Grid,  FormControl,  Select } from "@mui/material";

import 'dayjs/plugin/customParseFormat';
import { useState, useEffect } from "react";



// icon 
import Header from "../../Layout/Header";

import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "react-i18next";
// import CustomAutocomplete from "../commancomponents/customAutoComplete";
import WarehouseCreate from "./AddNewWarehouse";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import CustomAutocomplete from "../../components/CustomeAutoComplete";



const AddWarehouseDetails = ({ handlecallback }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const [editPartyID, setEditPartyID] = useState(0)

    const [warehouseList, setWarehouseList] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState([]);

    // State variables
    const [warehouseCode, setWarehouseCode] = useState('');
    const [zone, setZone] = useState('');
    const [subZone, setSubZone] = useState('');
    const [zoneWidth, setZoneWidth] = useState('');
    const [zoneLength, setZoneLength] = useState('');
    const [zoneHeight, setZoneHeight] = useState('');
    const [productType, setProductType] = useState('Reel');

    const [dimensions, setDimensions] = useState(''); // Single field for dimensions

    const [aisle, setAisle] = useState('1');
    const [racks, setRacks] = useState('1');
    const [rackLevels, setRackLevels] = useState('1');
    const [bins, setBins] = useState('1');
    const [stack, setStack] = useState('1');
    const [maxStackDiaRange, setMaxStackDiaRange] = useState('100');

    const [maxCapacityInBins, setMaxCapacityInBins] = useState('0.5');

    const [paymentTerms, setPaymentTerms] = useState([]);
    const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
    const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
    const [paymentTermsID, setPaymentTermsID] = useState(0);
    const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);

    const [openPreviewModal, setOpenPreviewModal] = useState(false);


    const [zoneCode, setZoneCode] = useState([]);


    const handleOpenMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    const handleCloseMenu = (setter) => () => {
        setter(null);
    };

    const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
        setSelectedOption(option);
        setSelectedID(option ? option.id : null);
        handleCloseMenu();
    };


    const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);

    const handleAddOption = (label) => () => {
        if (label == 'Warehouse') {
            setPaymentTermDialogOpen(true);
        }
    };





    const callback = () => {
        handlecallback();
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        // Parse dimensions
        const [zoneWidth, zoneLength, zoneHeight] = dimensions.split('x').map(dim => parseFloat(dim.trim()));
        const id_warehouse = selectedPaymentTerm.id;

        // Log or handle the parsed dimensions
        console.log({
            id_warehouse,
            zone,
            subZone,
            dimensions: { width: zoneWidth, length: zoneLength, height: zoneHeight },
            productType,
            aisle,
            racks,
            rackLevels,
            bins
        });

        // Validation: Check if any required parameter is null or undefined
        const requiredParameters = [
            { name: 'Warehouse ID', value: id_warehouse },
            { name: 'Storage Type', value: productType },
            { name: 'Zone Code', value: zone },
            // { name: 'Sub Zone Code', value: subZone },
            { name: 'Zone Width', value: zoneWidth },
            { name: 'Zone Length', value: zoneLength },
            { name: 'Zone Height', value: zoneHeight },
            { name: 'Total Aisles', value: aisle },
            { name: 'Total Racks', value: racks },
            { name: 'Total Rack Levels', value: rackLevels },
            { name: 'Total Bins', value: bins },
            { name: 'Max Capacity In bin', value: maxCapacityInBins }
        ];

        const missingParameter = requiredParameters.find(param => param.value === null || param.value === undefined || param.value === '');

        if (missingParameter) {
            alert(`Please provide a valid value for ${missingParameter.name}.`);
            return;
        }


        const parameters = {
            id_warehouse: id_warehouse,
            storage_type: productType,
            zone_code: zone,
            sub_zone_code: subZone,
            zone_width: zoneWidth,
            zone_length: zoneLength,
            zone_height: zoneHeight,
            total_aisles: aisle,
            total_racks: racks,
            total_levels: rackLevels,
            total_bins: bins,
            auto_generate_code: true,
            total_stacking_count: stack,
            max_diameter_in_stack: maxStackDiaRange,
            max_capacity_in_bins:maxCapacityInBins,
        };

        callApi(API_ENDPOINTS.WAREHOUSE_INSERT_LOCATION, 'POST', { 'Content-Type': 'application/json' }, parameters)
            .then(data => {
                if (data && data.length > 0) {
                    alert("Zone was created successfully");
                    setAisle('1');
                    setRacks('1');
                    setRackLevels('1');
                    setBins('1');
                    setStack('1');
                    setMaxStackDiaRange('100');
                    setZone('');
                    setDimensions('');
                    
                }
            })
            .catch(error => {
                alert(error.message);
            });


    };





    const callLoadZoneCode = () => {

        const para = {
            p_companyid: 1,
        }

        callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPaymentTerms(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }



    useEffect(() => {
        if (paymentTermsID) {

            const para = {
                p_companyid: 1,
                p_id_warehouse: paymentTermsID,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_ZONE_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setZoneCode(data[0].zone_code);
                        setZone(data[0].zone_code);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [paymentTermsID]);



    // API CALL WARE    HOUSE LIST
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.WAREHOUSE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPaymentTerms(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    // product based location enabled process
    const [isEnabled, setIsEnabled] = useState(true);
    const EnableSheetLocationMode = (value) => {

        if (value === 'reel') {
            setIsEnabled(true);
        }
        else {
            setIsEnabled(false);
        }

    };

    return (
        <form onSubmit={handleSubmit} style={{ padding: '0px' }}>

            <Box>
                <Header title={editPartyID == 0 ? 'Add Location' : 'Edit Warehouse Location'} subtitle="" callback={callback} />
                <Divider />
                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container  >
                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontWeight="bold"> Warehouse Name </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                                    <CustomAutocomplete
                                        label="Warehouse"
                                        options={paymentTerms}
                                        selectedOption={selectedPaymentTerm}
                                        setSelectedOption={setSelectedPaymentTerm}
                                        setAnchorEl={setPaymentTermAnchorEl}
                                        anchorEl={paymentTermAnchorEl}
                                        handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                                        handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                                        filterText={paymentTermFilterText}
                                        setFilterText={setPaymentTermFilterText}
                                        handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                                        handleAddOption={handleAddOption('Warehouse')}
                                        selectedID={paymentTermsID}
                                        setSelectedID={setPaymentTermsID}
                                        isRequired={true}
                                    />
                                </Grid>

                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Storage Product
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <FormControl fullWidth variant="outlined">
                                        {/* <InputLabel>Product Type</InputLabel> */}
                                        <Select
                                            size="small"
                                            value={productType}
                                            onChange={(e) => { setProductType(e.target.value); EnableSheetLocationMode(e.target.value) }}
                                            // label="Product Type"
                                            required
                                        >
                                            <MenuItem value="reel">Reel</MenuItem>
                                            <MenuItem value="bundle">Bundle</MenuItem>
                                            <MenuItem value="pallet">Pallet</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Zone Code
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        size="small"
                                        // label="Zone"
                                        variant="outlined"
                                        value={zone}
                                        onChange={(e) => setZone(e.target.value)}
                                        required
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Sub-Zone code (optional)
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        //label="Sub-Zone (Optional)"
                                        variant="outlined"
                                        value={subZone}
                                        onChange={(e) => setSubZone(e.target.value)}
                                    />
                                </Grid> */}

                            </Grid>

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        {/* Zone Dimensions (Width x Length x Height in meters) */}
                                        Zone Dimensions
                                    </Typography>
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        {/* Zone Dimensions (Width x Length x Height in meters) */}
                                        (W x L x H in meters)
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        // label="Dimensions (Width x Length x Height in meters)"
                                        variant="outlined"
                                        value={dimensions}
                                        onChange={(e) => setDimensions(e.target.value)}
                                        placeholder="e.g., 100 x 100 x 10"
                                        required
                                    />
                                </Grid>
                            </Grid>

                            <Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Total Aisles
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                    <TextField
                                        fullWidth
                                        disabled
                                        size="small"
                                        type="number"
                                        variant="outlined"
                                        value={aisle}
                                        onChange={(e) => setAisle(e.target.value)}
                                        required
                                    />
                                </Grid>

                                {!isEnabled && (
                                    <>

                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Total Rack
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={racks}
                                                onChange={(e) => setRacks(e.target.value)}
                                                required
                                            />
                                        </Grid>
                                    </>
                                )}

                            </Grid>
                            {!isEnabled && (
                                <>
                                    <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Number of Levels in Rack
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={rackLevels}
                                                onChange={(e) => setRackLevels(e.target.value)}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Bins per Level
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={bins}
                                                onChange={(e) => setBins(e.target.value)}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                               Max.Capacity In Bin 
                                            </Typography>
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                              in MT
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={maxCapacityInBins}
                                                onChange={(e) => setMaxCapacityInBins(e.target.value)}
                                                required
                                            />
                                        </Grid>                                        

                                    </Grid>
                                </>
                            )}

                            {isEnabled && (
                                <>
                                    <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Number of Stack in Aisle
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                // disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={stack}
                                                onChange={(e) => setStack(e.target.value)}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                Max Diameter in Stack
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={2} xl={2}>
                                            <TextField
                                                fullWidth
                                                // disabled={isEnabled}
                                                size="small"
                                                type="number"
                                                variant="outlined"
                                                value={maxStackDiaRange}
                                                onChange={(e) => setMaxStackDiaRange(e.target.value)}
                                            />
                                        </Grid>

                                    </Grid>
                                </>
                            )}

                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                    <Button variant="contained" color="primary" type="submit">
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>

                </Box>

                <WarehouseCreate open={isPaymentTermDialogOpen} onClose={() => { setPaymentTermDialogOpen(false); callLoadZoneCode(); }} terms={paymentTerms} setTerms={setPaymentTerms} />
                {/* <WarehouseLayout /> */}

            </Box>
        </form>
    );

};
export default AddWarehouseDetails;